import actionTypes from "./actionTypes";

const initialState = {
  config: [],
  configAlerts: [],
  configHolidays: {
    th: [],
  },
  employee: null,
  ledgers: [],
  ledgersTotal: [],
  linesAvailable: [],
  linesTransient: [],
  linesTransientTotal: [],
  me: {
    clients: [],
    config: [],
    configAlerts: [],
    configHolidays: {
      th: [],
    },
    info: {},
    job: null,
    jobs: [],
    ledger: null,
    ledgers: [],
    ledgersTotal: {},
    line: null,
    lines: [],
    linesTotal: {},
  },
  payroll: null,
  payrollLine: null,
  payrolls: [],
  error: null,
};

export default function reducer(prevState = initialState, action) {
  const state = {
    ...prevState,
    me: {
      ...prevState.me,
    },
  };

  switch (action.type) {
    case actionTypes.STORE:
      state[action.storageKey] = action.payload;
      return state;

    case actionTypes.STORE_CONFIG:
      state.config = action.payload || [];
      state.config.sort((a, b) => (a.id > b.id ? 1 : -1));
      return state;

    case actionTypes.STORE_CONFIG_ALERTS:
      state.configAlerts = action.payload;
      return state;

    case actionTypes.STORE_CONFIG_HOLIDAYS:
      state.configHolidays = {
        ...state.configHolidays,
        [action.payload.entity.toLowerCase()]: action.payload.data,
      };
      return state;

    case actionTypes.STORE_EMPLOYEE:
      state.employee = action.payload;
      return state;

    case actionTypes.STORE_LEDGERS:
      state.ledgers = action.payload;
      return state;

    case actionTypes.STORE_LEDGERS_TOTAL:
      state.ledgersTotal = action.payload;
      return state;

    case actionTypes.STORE_LINES_AVAILABLE:
      state.linesAvailable = action.payload;
      return state;

    case actionTypes.STORE_LINES_TRANSIENT:
      state.linesTransient = action.payload;
      return state;

    case actionTypes.STORE_LINES_TRANSIENT_TOTAL:
      state.linesTransientTotal = action.payload;
      return state;

    case actionTypes.STORE_ME_CLIENTS:
      state.me.clients = action.payload;
      return state;

    case actionTypes.STORE_ME_CONFIG:
      state.me.config = action.payload;
      return state;

    case actionTypes.STORE_ME_CONFIG_ALERTS:
      state.me.configAlerts = action.payload;
      return state;

    case actionTypes.STORE_ME_CONFIG_HOLIDAYS:
      state.me.configHolidays = {
        ...state.me.configHolidays,
        [action.payload.entity.toLowerCase()]: action.payload.data,
      };
      return state;

    case actionTypes.STORE_ME_INFO:
      state.me.info = action.payload;
      return state;

    case actionTypes.STORE_ME_JOB:
      state.me.job = action.payload;
      return state;

    case actionTypes.STORE_ME_JOBS:
      state.me.jobs = action.payload;
      return state;

    case actionTypes.STORE_ME_LEDGER:
      state.me.ledger = action.payload;
      return state;

    case actionTypes.STORE_ME_LEDGERS:
      state.me.ledgers = action.payload;
      return state;

    case actionTypes.STORE_ME_LEDGERS_TOTAL:
      state.me.ledgersTotal = action.payload;
      return state;

    case actionTypes.STORE_ME_LINE:
      state.me.line = action.payload;
      return state;

    case actionTypes.STORE_ME_LINES:
      state.me.lines = action.payload;
      return state;

    case actionTypes.STORE_ME_LINES_TOTAL:
      state.me.linesTotal = action.payload;
      return state;

    case actionTypes.STORE_PAYROLL:
      state.payroll = action.payload;
      return state;

    case actionTypes.STORE_PAYROLL_LINE:
      state.payrollLine = action.payload;
      return state;

    case actionTypes.STORE_PAYROLLS:
      state.payrolls = action.payload;
      return state;

    case actionTypes.UPDATE_PAYROLL:
      state.payroll = {
        ...state.payroll,
        ...action.payload,
      };
      return state;

    case actionTypes.PRP_REQUEST_FAILED:
      state.error = action.payload;
      return state;

    default:
      return state;
  }
}
